/* eslint-disable no-console */
import React from 'react';
import './styles.scss';

function Presentations() {
  return (
    <div>
      <div className="news" id="news">
        <ul>
          <li>
            <p>
              <b>Aug, 2026 </b>
              – Contributor to the <a href="https://github.com/6chaoran/jupyter-summarytools" target="_blank" rel="noreferrer">Python implementation of summarytools</a> for generating standardized, comprehensive DataFrame summaries inside Jupyter notebooks.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jan, 2026 </b>
              – Excited to share that my most recent postdoctoral work is now available as a <a href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=6145286" target="_blank" rel="noreferrer">preprint</a>.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Sep, 2025 </b>
              – Co-organizer of the weekly <a href="https://www.imperial.ac.uk/mathematical-finance/events/finance-and-stochastics/" target="_blank" rel="noreferrer">Finance & Stochastics seminars</a> of the Imperial College Mathematical Finance group.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Mar, 2025 </b>
              – Our paper <a href="https://doi.org/10.1111/mafi.12388" target="_blank" rel="noreferrer">"RL with Dynamic Convex Risk Measures"</a> has been recognized as a top cited article in Mathematical Finance among work published in 2023.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jun, 2024 </b>
              – Started a new position as a Research Associate at Imperial College London.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Feb, 2024 </b>
              – Invited to present my research work at the
              <a href="https://statqam.uqam.ca/" target="_blank" rel="noreferrer"> STATQAM Seminar</a>
              , in Montréal on February 15, 2024.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jun, 2023 </b>
              – Recipient of the DoSS Doctoral Early Research Excellence Award from the University of Toronto.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jun, 2023 </b>
              – Recipient of the
              <a href="https://www.siam.org/prizes-recognition/activity-group-prizes/detail/siag-fme-conference-paper-prize" target="_blank" rel="noreferrer"> SIAG/FME Conference Paper Prize</a> at the
              <a href="https://www.siam.org/conferences/cm/conference/fm23" target="_blank" rel="noreferrer"> SIAM Conference on Financial Mathematics and Engineering</a>
              , in Philadelphia on June 6-9, 2023.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Oct, 2022 </b>
              – Invited to present my research work at the
              <a href="https://meetings.informs.org/wordpress/indianapolis2022" target="_blank" rel="noreferrer"> INFORMS Annual Meeting</a>
              , in Indianapolis on October 16-19, 2022.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jan, 2022 </b>
              – Visiting researcher at the
              <a href="https://www.oxford-man.ox.ac.uk/previous-visitors/" target="_blank" rel="noreferrer"> Oxford-Man Institute</a>
              , University of Oxford, during a 6 month period; invited by
              <a href="https://sites.google.com/site/alvarocartea/home" target="_blank" rel="noreferrer"> Prof. Álvaro Cartea</a>.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Sep, 2021 </b>
              – Member of the program committee for the
              <a href="https://ai-finance.org/" target="_blank" rel="noreferrer"> International Conference on AI in Finance</a>
              ; part of the double-blind peer-reviewed process.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jun, 2021 </b>
              – Member of the organizing committee for the
              <a href="https://ssc.ca/en/meetings/annual/2021-annual-meeting/ninth-annual-canadian-statistics-student-conference" target="_blank" rel="noreferrer"> Canadian Statistics Student Conference 2021</a>
              , held online (instead of at Memorial University in St. John's due to COVID-19) on June
              5, 2021.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>May, 2020 </b>
              – Member of the organizing committee for the
              <a href="https://ssc.ca/en/meetings/annual/2020-annual-meeting/canadian-statistics-student-conference" target="_blank" rel="noreferrer"> Canadian Statistics Student Conference 2020</a>
              , held online (instead of at Carleton University in Ottawa due to COVID-19) on May 30,
              2020; part of the translation team, chair of a session and chat moderator.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Mar, 2019 </b>
              – Co-organized the Statistics Student Summit in Montreal, held at UQAM on March 15,
              2019. This new initiative aimed at bringing together young
              French-speaking statisticians for a day of talks.
              <a href="http://probability.ca/jeff/" target="_blank" rel="noreferrer"> Jeffrey S. Rosenthal </a>
              and
              <a href="https://sahirbhatnagar.com/" target="_blank" rel="noreferrer"> Sahir Rai Bhatnagar </a>
              were our two plenary speakers.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Presentations;
